/**
 * Single chip sprite. Uses the same CDN coin images as the Flutter Flame
 * version (imgCoins1.png..imgCoins6.png) when available, falls back to a
 * yellow filled circle if image load fails.
 */
import { Assets, Container, Graphics, Sprite, Texture } from 'pixi.js';

const CDN_BASE = 'https://imagebank.b-cdn.net/AMG/Common/imgCoins';

const coinTextureCache = new Map<number, Promise<Texture | null>>();

export function loadCoinTexture(chipType: number): Promise<Texture | null> {
  const t = Math.max(1, Math.min(6, Math.floor(chipType)));
  let p = coinTextureCache.get(t);
  if (p) return p;
  p = Assets.load<Texture>(`${CDN_BASE}${t}.png`).catch(() => null);
  coinTextureCache.set(t, p);
  return p;
}

export function preloadCoinTextures(): Promise<unknown> {
  return Promise.all([1, 2, 3, 4, 5, 6].map(loadCoinTexture));
}

export class ChipSprite extends Container {
  readonly value: number;
  readonly chipType: number;

  constructor(value: number, chipIndex: number) {
    super();
    this.value = value;
    this.chipType = (chipIndex % 6) + 1;

    const fallback = new Graphics();
    const r = 15;
    fallback.circle(0, 0, r).fill({ color: 0xffd54f });
    fallback.circle(0, 0, r).stroke({ color: 0xfff8e1, width: 2 });
    this.addChild(fallback);

    void loadCoinTexture(this.chipType).then((tex) => {
      if (!tex) return;
      fallback.destroy();
      const sprite = new Sprite(tex);
      sprite.anchor.set(0.5);
      const target = 30;
      sprite.width = target;
      sprite.height = target;
      this.addChildAt(sprite, 0);
    });
  }
}
